export const getPermissions = () => {
  try {
    return JSON.parse(localStorage.getItem("permissions")) || [];
  } catch {
    return [];
  }
};

export const hasPermission = (permission) => {
  return getPermissions().includes(permission);
};

export const hasAnyPermission = (permissionList = []) => {
  const permissions = getPermissions();
  return permissionList.some((item) => permissions.includes(item));
};